export enum CollectionType {
    email = 'email',
    phone = 'phone',
    totp = 'totp'
}